import axios from './axiosInstance';


const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const AddExtra=({token,extra}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/extras/add`,extra)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const ChangeExtrasVisibility=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/extras/changeVisibility`,data)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteExtra=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/extras/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteExtras=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/extras/bulkDelete`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetExtra=({token,_id,venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/extras/${_id}`,{venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetExtras=({token, venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/extras/`,{venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteExtra=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/extras/undelete/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteExtras=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/extras/undelete/bulk`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UpdateExtra=({token,extra}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/extras/update/${extra._id}`,extra)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

export {
    AddExtra,
    ChangeExtrasVisibility,
    DeleteExtra,
    DeleteExtras,
    GetExtra,
    GetExtras,
    UnDeleteExtra,
    UnDeleteExtras,
    UpdateExtra
}


